import { useEffect, useState } from "react";
import { Phone, ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Manifesto", href: "#manifesto", testid: "nav-link-manifesto" },
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Equipment", href: "#equipment", testid: "nav-link-equipment" },
  { label: "Service Area", href: "#service-area", testid: "nav-link-service-area" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-[#1E1511]/85 backdrop-blur-xl border-b border-[#C85A32]/25"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between gap-6">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="w-9 h-9 rounded-sm bg-[#C85A32] flex items-center justify-center font-mono text-xs font-bold text-[#F7F2EB] tracking-tight transition-colors duration-300 group-hover:bg-[#E89D4B]">
            DVF
          </span>
          <span className="font-display text-lg font-semibold tracking-tight text-[#F7F2EB] leading-none">
            Desert Valley <span className="italic text-[#E89D4B]">Freight</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testid}
              className="font-mono text-[11px] tracking-[0.22em] uppercase text-[#E6DACB]/80 hover:text-[#E89D4B] transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+16026694590"
            data-testid="nav-phone-button"
            className="hidden sm:flex items-center gap-2 font-mono text-[11px] tracking-[0.15em] text-[#E6DACB] border border-[#C85A32]/40 rounded-full px-4 py-2 hover:border-[#E89D4B] hover:text-[#E89D4B] transition-colors duration-300"
          >
            <Phone size={13} />
            (602) 669-4590
          </a>
          <a
            href="#quote"
            data-testid="nav-quote-button"
            className="flex items-center gap-1.5 bg-[#C85A32] text-[#F7F2EB] font-mono text-[11px] tracking-[0.15em] uppercase rounded-full px-5 py-2.5 hover:bg-[#E89D4B] hover:text-[#1E1511] transition-colors duration-300"
          >
            Get a Quote
            <ArrowUpRight size={13} />
          </a>
        </div>
      </div>
    </header>
  );
};
